export type Scenario = {
    canHaveMultiConnexion: boolean;
    verificationMethods: VerificationMethodEnum[];
    fields: ScenarioFieldType[];
};

export enum VerificationMethodEnum {
    EMAIL = "email",
    SMS = "sms",
}

type ScenarioFieldType = {
    name: string;
    type: string;
    mandatory: boolean;
    unique: boolean;
    custom: boolean;
    validator?: string;
    translations: Record<string, string>;
};

export type FieldType = ScenarioFieldType & {
    showQRCode?: boolean;
    showSendPINByEmail?: boolean;
    onResendPINClick?: any;
};
